import { API_PATH } from "src/const/api-urls";
import { FR_HEADER, TO_HEADER } from "src/const/const-from-env";
import { BaseResponse } from "src/interface";
import { createCreDtTm, createMSGID } from "src/utils/helper";
import httpsService from "./httpsService";
import { DefaultHeaderFrSystm, DefaultHeaderToSystm } from "src/const";
import { IResponseInquiryBill } from "src/interface/inquiryBill/responseInquiryBill";

interface IResponseItem {
  data: {
    initialPremium: {
      orderId: string;
      preMafTerTaxAmt: string;
      topupAmt: string;
      totalAmt: string;
    };
    duePremium: {
      duePremiumInfo: [
        {
          premiumType: string;
          dueFrom: string;
          dueTo: string;
          dueAmt: string;
          checkDuaAtm: boolean;
        },
        {
          premiumType: string;
          dueFrom: string;
          dueTo: string;
          dueAmt: string;
          checkDuaAtm: boolean;
        }
      ];
      orderId: string;
    };
    topup: {
      orderId: string;
      minTopup: string;
      maxTopup: string;
    };
    reinstate: {
      totalAmt: string;
      orderId: string;
    };
    addRider: {
      orderId: string;
      totalAmt: string;
    };
    changePaymentFrequency: {
      orderId: string;
      totalAmt: string;
    };
    idNumber: string;
    status: string;
    prdName: string;
    phName: string;
    laName: string;
    ccAllow: string;
    feeAmt: string;
    suspenseAmt: string;
    policyHolderDateOfBirth: string;
    lifeAssuredDateOfBirth: string;
    payFrequency: string;
  };
  msgSts: {
    code: string;
    message: string;
  };
}
export interface IInquiryRequestItem {
  result: IResponseItem;
  callbackURL: string;
  frSystm: string;
}

export interface IResponse {
  data: IInquiryRequestItem;
  msgSts: {
    code: any;
    message: string;
  };
}

export const getDataInquiryFromAnotherPlatfom = (id: string) => {
  const params = {
    requestId: id,
    msgId: "defaultMsgId",
  };
  return httpsService.get<null, BaseResponse<IResponse>>(
    API_PATH.INQUIRY_REQUEST_ITEM,
    {
      headers: {
        creDtTm: createCreDtTm(),
        frSystm: DefaultHeaderFrSystm,
        toSystm: DefaultHeaderToSystm,
      },
      params: params,
    }
  );
};
